import { useLangContext } from "@assets/spa/context/lang";
export function useLang() {
    return useLangContext();
}
